export const LicenseState = {
  Active: 'ACTIVE',
  Preactive: 'PREACTIVE',
} as const;

export const LicenseCpi = {
  EditionAdmin: 'edition_admin',
} as const;

export interface LicenseInterface {
  cpi: string;
  ean?: string;
  state: 'ACTIVE' | 'PREACTIVE';
  type: 'ABONNEMENT' | 'VASTE_PERIODE' | 'SCHOOLJAARLICENTIE';
  startDate?: string;
  activationDate?: string;
  endDate?: string;
}

export type UserRoles =
  'thiememeulenhoff/license/teacher' | 'thiememeulenhoff/license/student';

export interface UserInterface {
  identifier: string;
  name: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  licenses: Array<LicenseInterface>;
  roles?: Array<UserRoles>;
  brin: string | null;
}
